import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getWrittenExecutiveSummary: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<string | undefined> = (fetchContext, nominationId, accessToken) =>
    fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/written-executive-summary`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
      },
    }).then((response) => responseErrorHandler<string | undefined>(fetchContext.errorStore, response, 'get written executive summary', true, [404]));
